import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaClock, FaSignInAlt } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const SessionExpiredModal = () => {
  const { showSessionExpiredModal, setShowSessionExpiredModal, setShowSignInModal } = useAuth();

  const handleClose = () => {
    setShowSessionExpiredModal(false);
    setShowSignInModal(true);
  };

  if (!showSessionExpiredModal) return null;

  return (
    <Modal 
      show={showSessionExpiredModal} 
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <style>{`
        .session-expired-modal .modal-content {
          border: none;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
        }
        
        .session-expired-modal .modal-header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 16px 16px 0 0;
          padding: 24px 28px;
        }
        
        .session-expired-modal .modal-body {
          padding: 28px;
        }
        
        .session-expired-modal .clock-icon {
          font-size: 64px;
          color: #667eea;
          margin-bottom: 20px;
        }
      `}</style>

      <Modal.Header>
        <Modal.Title style={{ 
          fontSize: '1.5rem', 
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <FaClock />
          Session Expired
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{ textAlign: 'center' }}>
          <FaClock className="clock-icon" />
          
          <h4 style={{ 
            color: '#2c3e50',
            marginBottom: '16px',
            fontWeight: 600
          }}>
            Your session has expired
          </h4>
          
          <p style={{ 
            color: '#5a6c7d',
            fontSize: '1rem',
            lineHeight: '1.6',
            marginBottom: '24px'
          }}>
            For your security, we automatically log you out after 30 minutes of inactivity.
            Please sign in again to continue.
          </p>

          <Button
            variant="primary"
            size="lg"
            onClick={handleClose}
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 32px',
              fontSize: '1.1rem',
              fontWeight: 600,
              boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              margin: '0 auto'
            }}
          >
            <FaSignInAlt />
            Sign In Again
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SessionExpiredModal;
